import Page from "../layout/Page";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import EViziteWidget from "../components/dashboad/EViziteWidget";
import CalisanSayisiWidget from "../components/dashboad/CalisanSayisiWidget";
import ToplamTesvikWidget from "../components/dashboad/ToplamTesvikWidget";
import IsKazaWidget from "../components/dashboad/IsKazaWidget";
import EBorcWidget from "../components/dashboad/EBorcWidget";
import TcknSorgulaWidget from "../components/dashboad/TcknSorgulaWidget";
import TescilIzlemeWidget from "../components/dashboad/TescilIzlemeWidget";
import MahsuplarWidget from "../components/dashboad/MahsuplarWidget";
import GirisCikis from "../components/dashboad/GirisCikisWidget";


const Dashboard = () => {

    const { t } = useTranslation();

    return (
        <Page title={t('menu.dashboard')}>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={3}>
                            <TescilIzlemeWidget />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <EViziteWidget />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={4}>
                                <Grid item xs={12}>
                                    <CalisanSayisiWidget />
                                </Grid>
                                <Grid item xs={12}>
                                    <ToplamTesvikWidget />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                            <Grid container spacing={2}>
                                <Grid item md={6} xs={12}>
                                    <IsKazaWidget />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <GirisCikis />
                                </Grid>

                                <Grid item md={6} xs={12}>
                                    <EBorcWidget />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <Grid container spacing={2}>
                                <Grid item md={12} xs={12}>
                                    <MahsuplarWidget />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>


            </Grid>


        </Page>
    )
}

export default Dashboard;
